import { createFileRoute } from '@tanstack/react-router'
import { SearchPage } from '../components/pages'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/it/ricerca')({
  head: () => staticRouteHead('search', 'it'),
  component: SearchPage,
})
